/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Admin_Billing_Confirm_BillInputs */



/**
* | output |
* | --- |
* | "Enable & bill {amount}" |
*
* @param {Partner_Admin_Billing_Confirm_BillInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_confirm_bill = /** @type {((inputs: Partner_Admin_Billing_Confirm_BillInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Confirm_BillInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktivieren & ${i?.amount} abrechnen`)
	return /** @type {LocalizedString} */ (`Enable & bill ${i?.amount}`)
});